import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";
import { useTenant } from "../lib/tenant.js";
import { useHomeContent } from "../templates/pages/home/useHomeContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/** The front page, laid out by the storefront template this environment chose. */
export function HomePage() {
  const { config } = useTenant();
  return (
    <PageTemplateView template={storefrontTemplateOf(config).home} content={useHomeContent()} />
  );
}
